export const testSettingConstants = {
  FETCH_DEFAULT_TEST_SETTINGS: "FETCH_DEFAULT_TEST_SETTINGS",
  FETCH_DEFAULT_TEST_SETTINGS_SUCCESS: "FETCH_DEFAULT_TEST_SETTINGS_SUCCESS",
  FETCH_DEFAULT_TEST_SETTINGS_FAILED: "FETCH_DEFAULT_TEST_SETTINGS_FAILED",

  FETCH_GROUP_TEST_SETTINGS: "FETCH_GROUP_TEST_SETTINGS",
  FETCH_GROUP_TEST_SETTINGS_SUCCESS: "FETCH_GROUP_TEST_SETTINGS_SUCCESS",
  FETCH_GROUP_TEST_SETTINGS_FAILED: "FETCH_GROUP_TEST_SETTINGS_FAILED",

  SAVE_TEST_SETTINGS: "SAVE_TEST_SETTINGS",
  SAVE_TEST_SETTINGS_SUCCESS: "SAVE_TEST_SETTINGS_SUCCESS",
  SAVE_TEST_SETTINGS_FAILED: "SAVE_TEST_SETTINGS_FAILED",

  FETCH_ACTIVE_TEST_SETTINGS: "FETCH_ACTIVE_TEST_SETTINGS",
  FETCH_ACTIVE_TEST_SETTINGS_SUCCESS: "FETCH_ACTIVE_TEST_SETTINGS_SUCCESS",
  FETCH_ACTIVE_TEST_SETTINGS_FAILED: "FETCH_ACTIVE_TEST_SETTINGS_FAILED",

  FIND_LEVEL_ABOVE_TEST_SETTINGS: "FIND_LEVEL_ABOVE_TEST_SETTINGS",
  FIND_LEVEL_ABOVE_TEST_SETTINGS_SUCCESS:
    "FIND_LEVEL_ABOVE_TEST_SETTINGS_SUCCESS",
  FIND_LEVEL_ABOVE_TEST_SETTINGS_FAILED: "FIND_LEVEL_ABOVE_TEST_SETTINGS_FAILED"
}
